import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/ChatWithSupport/ChatWithSupport.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/footer/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/header/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_providers/ChatContext.jsx");
